import { DownloadIcon, PreviewIcon } from '@assets/icons';
import { IconButton } from '@components/button';
import { InternalLink } from '@components/link';
import { Tooltip } from '@components/tooltip';
import { DateToNowDisplay, Typography } from '@components/typography';
import { Dataset } from '@generated/graphql';
import { Box, TableCell } from '@mui/material';
import { memo } from 'react';

type WorkspacesRecentDatasetsRowProps = {
  dataset: Dataset;
  onDownload: (dataset: Dataset) => void;
  onPreview: (datasetId: string) => void;
};

export const WorkspacesRecentDatasetsRow = memo(
  ({ dataset, onDownload, onPreview }: WorkspacesRecentDatasetsRowProps) => {
    return (
      <>
        <TableCell>
          <InternalLink
            to={`datasets/?datasetId=${dataset.datasetId}`}
            unstyled
            sx={{ '&:hover': { textDecoration: 'underline' } }}
          >
            <Typography handleOverFlow>{dataset?.name}</Typography>
          </InternalLink>
        </TableCell>
        <TableCell>
          <DateToNowDisplay date={dataset?.createdAt} />
        </TableCell>
        <TableCell>
          <Typography handleOverFlow>{dataset?.runs}</Typography>
        </TableCell>
        <TableCell>
          <Box display="flex">
            <Tooltip title="Download">
              <IconButton onClick={() => onDownload(dataset)} Icon={DownloadIcon} />
            </Tooltip>
            <Tooltip title="Preview">
              <IconButton onClick={() => onPreview(dataset.datasetId)} Icon={PreviewIcon} />
            </Tooltip>
          </Box>
        </TableCell>
      </>
    );
  },
);
